import React from 'react'
import PropTypes from 'prop-types'
import EnhancedVideoPlayer from '../EnhancedVideoPlayer'

/**
 * VideoPlayerEntry - Wrapper component for EnhancedVideoPlayer to be used with Contentful
 * This component adapts Contentful field names to EnhancedVideoPlayer props
 */
const VideoPlayerEntry = ({
  videoUrl,
  title,
  aspectRatio,
  autoPlay,
  showControls,
  muted,
  loop,
  showThumbnail,
  thumbnailUrl,
  enableLazyLoad,
  customClassName,
  showTitle,
  onPlay,
}) => {
  if (!videoUrl) {
    console.warn('VideoPlayerEntry: videoUrl is required')

    return null
  }

  return (
    <div className="my-8" data-testid="video-player-entry">
      <EnhancedVideoPlayer
        src={videoUrl}
        title={title || 'Video Player'}
        aspectRatio={aspectRatio || '16:9'}
        autoPlay={autoPlay || false}
        controls={showControls !== false} // Default to true
        muted={muted || false}
        loop={loop || false}
        light={showThumbnail !== false} // Default to true
        thumbnail={thumbnailUrl}
        lazy={enableLazyLoad !== false} // Default to true
        className={customClassName || ''}
        onPlay={onPlay}
      />
      {title && showTitle && (
        <figcaption className="text-gray-600 mt-4 text-center text-sm">
          {title}
        </figcaption>
      )}
    </div>
  )
}

VideoPlayerEntry.propTypes = {
  videoUrl: PropTypes.string.isRequired,
  title: PropTypes.string,
  aspectRatio: PropTypes.oneOf(['16:9', '4:3', '1:1', '21:9', '9:16']),
  autoPlay: PropTypes.bool,
  showControls: PropTypes.bool,
  muted: PropTypes.bool,
  loop: PropTypes.bool,
  showThumbnail: PropTypes.bool,
  thumbnailUrl: PropTypes.string,
  enableLazyLoad: PropTypes.bool,
  customClassName: PropTypes.string,
}

VideoPlayerEntry.defaultProps = {
  title: '',
  aspectRatio: '16:9',
  autoPlay: false,
  showControls: true,
  muted: false,
  loop: false,
  showThumbnail: true,
  thumbnailUrl: '',
  enableLazyLoad: true,
  customClassName: '',
  showTitle: false,
}

export default VideoPlayerEntry
